import React from "react";

import CheckFormSettingField from "app/shared/utility/CheckFormSettingField";

//components
import DetailStep1 from "./components/step1";
import DetailStep2 from "./components/step2";
import DetailStep3 from "./components/step3";
import { useTranslation } from "react-i18next";

//assets
import { TimelineCalendarIcon } from "assets/Iconsv2/Iconsv2";
import DocumentComponent from "../documentComponent";
import CostingComponent from "../costingComponent";
import { NM } from "app/shared/constants/ModuleNames";

const DetailStepForms = ({ state, functionContent, variablesObj, costingdata }) => {
  const { t } = useTranslation(['nm', 'util']);
  return (
    <li>
      <div className="cbp_tmicon cbp_tmicon-mail">
        <TimelineCalendarIcon />
      </div>
      <div className="cbp_tmlabel clide-v2-white-box">
        <div className="row">
          <div className="col-12 col-md-8 col-lg-8">
            <p className="clide-v2-fs-4 clide-v2-primary-color fw-bold pt-3 mb-2">
            {t('nmInvestigationAnalysis')}

            </p>
          </div>
          <div className="col-12 col-md-4 col-lg-4 text-end">
            <button className="clide-v2-btn-template clide-v2-primary my-1 px-3 ">
              <span className="clide-v2-white-color">{t('analysis')}</span>
            </button>
          </div>
        </div>
        <DetailStep1
          state={state}
          functionContent={functionContent}
          variablesObj={variablesObj}
        />
        {CheckFormSettingField(state.nmFormSetting, "Document") &&
          <div className="clide-v2-white-box my-5 mx-4">
            <DocumentComponent t={t} id={state.nmDetail.nm_id} editFlag = {state.nmDetail.edit_flag} module={NM} />
          </div>
        }
        <DetailStep2
          state={state}
          functionContent={functionContent}
          variablesObj={variablesObj}
        />
        {CheckFormSettingField(state.nmFormSetting, "Cost") && <CostingComponent t={t} nmDetail={state.nmDetail} costingdata={costingdata}/>}
         
        <DetailStep3
          state={state}
          functionContent={functionContent}
          variablesObj={variablesObj}
        />
       
      </div>
    </li>
  );
};

export default DetailStepForms;
